<template>
  <Modal v-model="visible" :width="1000">
    <template #header>
      <p>变更资产计费策略</p>
    </template>

    <p  class="m-b-5" style="margin:16rpx 0px;">
      <strong class="m-r-10">变更项</strong>
    </p>
    <Row class="m-b-10">
      <i-col span="6">
        <span class="title">编码</span>{{ changeBean.objectCode }}
      </i-col>
      <i-col span="6">
        <span class="title">站点</span>{{ changeBean.stationName }}
      </i-col>
      <i-col span="6">
        <span class="title">类型</span>{{ changeBean.resourceTypeName }}
      </i-col>
      <i-col span="6">
        <span class="title">计费数量</span>{{ changeBean.number }} {{ formatObjectTypeName(changeBean.objectType) }}
      </i-col>
    </Row>

    <Row>
      <i-col span="24">
        <div  style="margin:10px 0px;">
          <strong class="text-orange">已缴费周期</strong>
          (不可变更)
        </div>
      </i-col>
    </Row>
    <Table :columns="billColumn" stripe size="small" :data="billData"></Table>

    <Row class="m-t-5">
      <i-col span="24">
        <div  style="margin:10px 0px;">
          <strong>可变更计费项</strong>
        </div>
      </i-col>
    </Row>

    <Row class="table-title p-t-5 p-b-5">
        <i-col span="3">计费类型</i-col>
        <i-col span="3">开始日期</i-col>
        <i-col span="3">结束日期</i-col>
        <i-col span="3">计费数量</i-col>
        <i-col span="3">计费单价</i-col>
        <i-col span="3">小计</i-col>
        <i-col span="3">合计</i-col>
        <i-col span="3">操作</i-col>
    </Row>
    <Row v-for="(item,index) in rentSettingData" :key="index" class="p-t-5 p-b-5"  :class="(index%2 === 0)?'table-row-1':'table-row-2'">
        <i-col span="3">
          <i-select v-if="item.$isEdit" v-model="item.feeType" size="small" style="width: 110px">
            <Option v-for="fee in feeArray" :key="fee.id" :value="fee.id">{{ fee.name }}</Option>
          </i-select>
          <span v-else>{{ item.feeTypeName }}</span>
        </i-col>
        <i-col span="3">
          <DatePicker v-if="item.$isEdit" type="date" v-model="item.startDate"
            :clearable="false" size="small" style="width: 100px"></DatePicker>
          <span v-else>{{ item.startDate }}</span>
        </i-col>
        <i-col span="3">
          <DatePicker v-if="item.$isEdit" type="date" v-model="item.endDate"
            :clearable="false" size="small" style="width: 100px"></DatePicker>
          <span v-else>{{ item.endDate }}</span>
        </i-col>
        <i-col span="3">
          <Input v-if="item.$isEdit" v-model="item.number" size="small" style="width: 80px"/>
          <span v-else>{{ item.number }}</span>
        </i-col>
        <i-col span="3">
          <Input v-if="item.$isEdit" v-model="item.signPrice" size="small" style="width: 80px"/>
          <span v-else>{{ item.signPrice }}</span>
        </i-col>
        <i-col span="3">
          <i-select v-if="item.$isEdit" v-model="item.dateUnit" size="small" style="width: 80px">
            <Option v-for="item in dateUnitArray" :value="item.value" :key="item.value"> {{ item.name }} </Option>
          </i-select>
          <span v-else>{{ item.monthPrice }} / {{ formatDateUnit(item.dateUnit) }}</span>
        </i-col>
        <i-col span="3">
          <span v-if="item.$isEdit">-</span>
          <span v-else>{{ item.totalPrice }}</span>
        </i-col>
        <i-col span="3">
          <template v-if="item.$isEdit">
            <a @click="handleSaveRow(item)">保存</a>
            <a class="m-l-5" @click="item.$isEdit=false">取消</a>
          </template>
          <template v-else>
            <a @click="handleEditRow(item)">编辑</a>
            <a class="m-l-5 delete" @click="handleDeleteRow(item)">删除</a>
          </template>
        </i-col>
    </Row>
    <p class="m-t-5">
      <a @click="handleAddRow"><Icon type="md-add" />新增计费项</a>
    </p>

    <template #footer>
      <i-button
        type="primary"
        :disabled="allowSubmit"
        @click="confirmRentSet()"
      >
        确认修改
      </i-button>
    </template>
  </Modal>
</template>

<script>
import { cloneDeep } from 'lodash'

import em from '@/utils/enum'
import { ParseDate } from '@/utils/dateFormat'
import { toMoney } from '@/utils/wnumb_own'
// apis
import { listObjectFee, changeObjectFeeList, computeFeePlan } from '@/api/invest/contract'
import { listDictLabel } from '@/api/invest/dict'
import { countDebtDurDate } from '@/api/invest/debt'

export default {
  components: {},
  props: {},
  data () {
    return {
      visible: false,
      changeBean: {}, // 当前需要变更的资产项
      billData: [],
      billColumn: [
        { title: '开始日期', key: 'startDate' },
        { title: '结束日期', key: 'endDate' },
        { title: '费用类型', key: 'feeTypeName' },
        {
          title: '已缴费金额',
          render: (h, data) => {
            return h('span', {
              attrs: {
                class: 'money'
              }
            }, toMoney(data.row.totalPrice))
          }
        }
      ],

      feeArray: [],
      dateUnitArray: em.dateUnitArray,

      submitBean: {
        coId: null,
        delIdList: [],
        feeList: [],
        feeType: 1
      },

      deleteRentSettingData: [], // 需要删除的数据集合
      rentSettingData: []
    }
  },
  mounted () {},
  created () {
    this.initBaseData()
  },
  methods: {
    initBaseData () {
      listDictLabel({ dictType: 'fee_type' }).then(res => {
        this.feeArray = res.map(x => {
          return {
            id: parseInt(x.id),
            name: x.name
          }
        })
      })
    },
    formatDateUnit (type) {
      const unit = this.dateUnitArray.find(x => x.value === type)
      return unit ? unit.name : ''
    },
    formatObjectTypeName (objectType) {
      let unit = ''
      if (objectType === 3007) {
        unit = ' 台'
      } else if ([3006, 3013].includes(objectType)) {
        unit = ' ㎡'
      }

      return unit
    },
    showModal (params) {
      this.changeBean = params
      this.visible = true

      this.submitBean.coId = params.id
      this.submitBean.feeType = params.feeType

      // 获取已生成账单，并创建结算单的区间数据。 统计合同已结算的费用的时间区间
      countDebtDurDate({ coId: params.id }).then(res => {
        this.billData = res
      })
      // 获取当前项的历史设置
      const query = {
        contractId: this.contractId,
        coId: params.id
      }
      listObjectFee(query).then(res => {
        this.rentSettingData = res
      })
    },

    // 添加行
    handleAddRow () {
      // copy表格最后一条数据
      const copyLastItem = cloneDeep(this.rentSettingData[this.rentSettingData.length - 1])

      copyLastItem.id = -1
      copyLastItem.$isEdit = true
      this.rentSettingData.push(copyLastItem)
    },
    // 编辑行
    handleEditRow (row) {
      this.$set(row, '$isEdit', true)
    },
    handleDeleteRow (row) {
      if (row.id !== -1) {
        this.deleteRentSettingData.push(row)
      }

      this.rentSettingData.splice(row._index, 1)
    },
    handleSaveRow (row) {
      row.startDate = ParseDate(row.startDate)
      row.endDate = ParseDate(row.endDate)

      const saveBean = {
        dateUnit: row.dateUnit,
        endDate: row.endDate,
        number: row.number,
        signPrice: row.signPrice,
        startDate: row.startDate
      }

      computeFeePlan(saveBean).then(res => {
        row.totalPrice = res.totalPrice
        row.monthPrice = res.monthPrice
        row.feeTypeName = this.feeArray.find(x => x.id === row.feeType).name
        row.$isEdit = false
        if (row.id > 0) { // 执行删除和添加操作
          row.$isUpdate = true
        }
      })
    },

    confirmRentSet () {
      this.$Modal.confirm({
        title: '操作确认',
        content:
          '确认保存当前租金策略？',
        onOk: () => {
          this.submitBean.delIdList = this.deleteRentSettingData.map(x => x.id)
          // 仅取发生变更和添加的行
          this.submitBean.feeList = this.rentSettingData.filter(x => (x.id === -1 || x.$isUpdate))

          changeObjectFeeList(this.submitBean).then((res) => {
            this.visible = false
            this.$emit('on-change-success')
          })
        }
      })
    }

  },
  computed: {
    contractId () {
      return this.$store.state.investmentContract.id
    },
    allowSubmit () {
      let allow = true
      for (let index = 0; index < this.rentSettingData.length; index++) {
        if (this.rentSettingData[index].$isEdit) {
          allow = false
          break
        }
      }

      return !allow
    }
  }
}
</script>
